import { Injectable, Inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';

import type { PostBootstrapInit } from './post-bootstrap-init';

@Injectable({
  providedIn: 'root'
})
export class MaterialService implements PostBootstrapInit {
  constructor(@Inject(MatIconRegistry) private matIconRegistry: MatIconRegistry) {
  }

  init(): void {
    this.matIconRegistry.setDefaultFontSetClass('td-icon');
  }
}
